<button bitButton [bitMenuTriggerFor]="itemOptions" buttonType="primary" type="button">
  @if (!hideIcon) {
    <bit-icon name="bwi-plus" class="tw-me-2" slot="start"></bit-icon>
  }
  {{ (hideIcon ? "createSend" : "new") | i18n }}
</button>
<bit-menu #itemOptions>
  <button type="button" bitMenuItem (click)="createSend(sendType.Text)">
    <bit-icon name="bwi-file-text" slot="start"></bit-icon>
    {{ "sendTypeText" | i18n }}
  </button>
  <button type="button" bitMenuItem (click)="createSend(sendType.File)">
    <bit-icon name="bwi-file" slot="start"></bit-icon>
    <div class="tw-flex tw-items-center tw-gap-2">
      {{ "sendTypeFile" | i18n }}
      <app-premium-badge></app-premium-badge>
    </div>
  </button>
</bit-menu>
